import type { GetChatThreadOutput } from '@erp/rpc';
import type { Message } from './agent-state.context';

type ThreadMessage = GetChatThreadOutput['messages'][number];

function restoreMessage(message: ThreadMessage): Message {
  const isAssistant = message.role === 'assistant';
  return {
    id: message.id,
    role: isAssistant ? 'assistant' : 'user',
    content: message.content,
    timestamp: new Date(message.createdAt),
    ...(isAssistant && { dbMessageId: message.id }),
    ...(message.channel && { channel: message.channel }),
    ...(message.toolCalls?.length && {
      toolResults: message.toolCalls.map((toolCall) => ({
        toolCallId: toolCall.toolCallId,
        toolName: toolCall.toolName,
        args: toolCall.args,
        result: toolCall.result,
      })),
    }),
    ...(message.attachments?.length && { attachments: message.attachments }),
  };
}

/** A saved thread as chat messages. The chat UI only renders user/assistant turns. */
export function restoreMessages(
  messages: GetChatThreadOutput['messages'],
): Message[] {
  return messages.flatMap((message) =>
    message.role === 'system' ? [] : [restoreMessage(message)],
  );
}
